module.exports = __webpack_public_path__ + "img/4.f059d96d.png";